export default function disableIosTextFieldZoom() {
	const el = document.querySelector("meta[name=viewport]");

	if (el !== null) {
		let content = el.getAttribute("content");
		let re = /maximum\-scale=[0-9\.]+/g;

		// @ts-expect-error
		if (re.test(content)) {
			// @ts-expect-error
			content = content.replace(re, "maximum-scale=1.0");
		} else {
			content = [content, "maximum-scale=1.0"].join(", ");
		}

		el.setAttribute("content", content);
	}
}
